export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-sand"
      style={{ borderTop: "1px solid rgba(26,58,79,0.08)" }}
    >
      <div className="mx-auto flex max-w-[1100px] flex-col items-start justify-between gap-3 px-6 py-16 md:flex-row md:items-center md:px-10">
        <p
          data-testid="footer-brand"
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 500,
            fontSize: "15px",
            color: "var(--color-deep-lake)",
          }}
        >
          Kat Ryder Consulting
        </p>
        <p
          data-testid="footer-copyright"
          style={{
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            color: "var(--color-soft-gray)",
          }}
        >
          © 2026 Kat Ryder Consulting
        </p>
      </div>
    </footer>
  );
}
